import { cn } from "cn";
import { Switch as SwitchPrimitive } from "radix-ui";
import * as React from "react";

/**
 * El interruptor de shadcn (new-york), pegado a mano.
 *
 * `checked` viaja dentro de `...props` en vez de sacarse y volver a ponerse:
 * este repositorio usa `exactOptionalPropertyTypes` y desestructurarla le
 * anade un `undefined` que el tipo de Radix no acepta (ver README de esta
 * carpeta). Si alguna vez la CLI lo "arregla" de vuelta, manda esto.
 */
function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-transparent transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="pointer-events-none block size-4 rounded-full bg-background ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-[2px]"
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
